import { DeleteOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Popconfirm, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  FileOutput,
  LabworkAttachmentOutput,
  PermissionsEnum,
} from 'gql/types';
import { AlignType } from 'rc-table/lib/interface';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.LabworkAttachmentsTable');

type Props = {
  onDownload: (file: FileOutput) => void;
  onShare?: (fileId: string) => void;
  onDelete?: (fileId: string) => void;
  isCurrentUserAllowed: (permission: PermissionsEnum) => boolean;
};

const { ShareLabworkResults, DetachLabworkFile } = PermissionsEnum;

export const getColumns = ({
  onDownload,
  onShare,
  onDelete,
  isCurrentUserAllowed,
}: Props) => {
  const canShareLabworkResults = isCurrentUserAllowed(ShareLabworkResults);
  const canDetachLabworkFile = isCurrentUserAllowed(DetachLabworkFile);
  const columns: ColumnsType<LabworkAttachmentOutput> = [
    {
      title: t('file'),
      width: '70%',
      render: (row: LabworkAttachmentOutput) => {
        return (
          <Typography.Link
            download
            onClick={async () => row.file && onDownload(row.file)}
          >
            {row.file.filename}
          </Typography.Link>
        );
      },
    },

    ...(canShareLabworkResults
      ? [
          {
            title: t('share'),
            width: '15%',
            align: 'center' as AlignType,
            render: ({ file }: LabworkAttachmentOutput) => {
              return <ShareAltOutlined onClick={() => onShare?.(file.id)} />;
            },
          },
        ]
      : []),
    ...(canDetachLabworkFile
      ? [
          {
            title: t('deleteFile'),
            width: '15%',
            align: 'center' as AlignType,
            render: ({ file }: LabworkAttachmentOutput) => {
              return (
                <Popconfirm
                  title={t('sureToDeleteAttachment')}
                  onConfirm={() => onDelete?.(file.id)}
                >
                  <DeleteOutlined />
                </Popconfirm>
              );
            },
          },
        ]
      : []),
  ];
  return columns;
};
